import React, { useState, useEffect, useMemo } from "react";
import "../KidInfo/Quests.css";
import "./Settings.css";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import UpdatePasswordForm from "./Security";
import BackButton from "../Goback/GoBack";
import SubscriptionHistoryModal from "./SubscriptionModal";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";

export const ParentSettings = () => {
  const { user, fetchWithAuth } = useAuth(); // Fetch user details from AuthContext
  const apiUrl = process.env.REACT_APP_API_URL;
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [loadingSubscriptions, setLoadingSubscriptions] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const isBilling =
    location.pathname.includes("billing") ||
    searchParams.get("tab") === "billing";
  const activeTab = isBilling ? "billing" : "account";

  const handleSubscriptionCancelled = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    const fetchSubscriptionData = async () => {
      if (!user || !user.token) {
        return;
      }

      setLoadingSubscriptions(true);
      try {
        const response = await fetchWithAuth(`${apiUrl}/parent/subscription`, {
          method: "GET",
        });

        if (!response.ok) {
          throw new Error(
            `Failed to fetch subscription: ${response.statusText}`
          );
        }

        const data = await response.json();
        setSubscriptionDetails(data);
      } catch (error) {
      } finally {
        setLoadingSubscriptions(false);
      }
    };

    fetchSubscriptionData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiUrl, user?.token, refreshTrigger]);

  const [selectedHistories, setSelectedHistories] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState([]);

  useEffect(() => {
    setSelectedHistories(subscriptionDetails?.user?.data || []);
    setSelectedInvoice(subscriptionDetails?.user?.invoices || []);
  }, [subscriptionDetails]);

  // Group by unique subscription_id
  const subscriptionGroups = useMemo(() => {
    const map = {};
    (subscriptionDetails?.user?.data || []).forEach((item) => {
      const key = item.subscription_id || `sub_${item.id}`;
      if (!map[key]) {
        map[key] = [];
      }
      map[key].push(item);
    });
    return Object.values(map);
  }, [subscriptionDetails]);

  const activeSubscriptionsCount = subscriptionGroups.filter((group) =>
    group.some((sub) => sub.status === "Active")
  ).length;
  const totalSubscriptionsCount = subscriptionGroups.length;

  const totalKidsCount = (subscriptionDetails?.user?.data || []).length;
  const activeKidsCount = (subscriptionDetails?.user?.data || []).filter(
    (sub) => sub.status === "Active"
  ).length;

  const paidAmount = Number(
    subscriptionDetails?.user?.paid_amount || 0
  ).toFixed(2);
  const currencySymbol =
    subscriptionDetails?.user?.currency === "USD" ? "$" : "₹";

  return (
    <div className="dashboardBody parent-settings-page">
      <div className="container-fluid p-0">
        <div className="p-0" id="mainContent">
          <div className="teacher-bodycontent parent-settings-bodycontent mb-4">
            <section>
                <div className="container-fluid parent-settings-container px-2 px-sm-3">
                  <div className="row mb-3 mb-sm-4">
                    <div className="col-md-12">
                      <BackButton />
                    </div>
                    <div className="col-md-12 justify-content-center align-self-center">
                      <p className="tchrdashboard-cmntitl mb-0">
                        Account Settings
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <ul
                        className="nav nav-tabs settingsNavTabs"
                        id="myTab"
                        role="tablist"
                      >
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link settingTab ${
                              activeTab === "account" ? "active" : ""
                            }`}
                            id="home-tab"
                            type="button"
                            role="tab"
                            aria-controls="home"
                            aria-selected={activeTab === "account"}
                            onClick={() => navigate("/parent/settings/account")}
                          >
                            Account
                          </button>
                        </li>

                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link settingTab ${
                              activeTab === "billing" ? "active" : ""
                            }`}
                            id="profile-tab"
                            type="button"
                            role="tab"
                            aria-controls="profile"
                            aria-selected={activeTab === "billing"}
                            onClick={() =>
                              navigate("/parent/settings/billing-and-plans")
                            }
                          >
                            Billing & Plans
                          </button>
                        </li>
                      </ul>
                      <div
                        className="adminform-layout parent-settings-card mt-3 mt-sm-4"
                        style={{ padding: "0px" }}
                      >
                        <div className="tab-content" id="myTabContent">
                          <div
                            className={`tab-pane fade parent-settings-tab-pane parent-settings-account-pane ${
                              activeTab === "account" ? "show active" : ""
                            }`}
                            id="home"
                            role="tabpanel"
                            aria-labelledby="home-tab"
                          >
                            <div className="row">
                              <div className="col-md-12">
                                <p className="settingTitl">
                                  {user?.user?.firstName ||
                                    user?.firstName ||
                                    "User Name Not Found"}
                                </p>
                                <div className="row">
                                  <label
                                    htmlFor="email"
                                    className="col-form-label col-12 col-md-3 addSchlAcuntFormLabelKids"
                                  >
                                    Email
                                  </label>
                                  <div className="col-12 col-md-9">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="email"
                                      value={user?.user?.email || user?.email}
                                      disabled
                                    />
                                  </div>
                                </div>
                                <UpdatePasswordForm />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`tab-pane fade mt-3 mt-sm-4 parent-settings-tab-pane parent-settings-billing-pane ${
                              activeTab === "billing" ? "show active" : ""
                            }`}
                            id="profile"
                            role="tabpanel"
                            aria-labelledby="profile-tab"
                          >
                          {/* Metrics Overview Cards */}
                          {loadingSubscriptions ? (
                            <div className="row g-2 g-sm-3 mb-3 mb-sm-4">
                              {[1, 2, 3].map((item) => (
                                <div className="col-12 col-md-4" key={item}>
                                  <div className="p-2 p-sm-3 bg-white rounded-3 border h-100 shadow-sm d-flex align-items-center">
                                    <div
                                      className="rounded-circle placeholder-glow me-3"
                                      style={{
                                        width: "48px",
                                        height: "48px",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <span className="placeholder rounded-circle w-100 h-100 bg-secondary-subtle d-block"></span>
                                    </div>
                                    <div className="placeholder-glow w-100">
                                      <span
                                        className="placeholder col-7 bg-secondary-subtle mb-2 d-block rounded"
                                        style={{ height: "12px" }}
                                      ></span>
                                      <span
                                        className="placeholder col-4 bg-secondary-subtle fs-3 d-block rounded"
                                        style={{ height: "24px" }}
                                      ></span>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="row g-2 g-sm-3 mb-3 mb-sm-4">
                              <div className="col-12 col-md-4">
                                <div className="p-2 p-sm-3 bg-white rounded-3 border h-100 shadow-sm d-flex align-items-center">
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                    style={{
                                      background: "#ecfdf5",
                                      color: "#059669",
                                      width: "48px",
                                      height: "48px",
                                      fontSize: "22px",
                                      flexShrink: 0,
                                    }}
                                  >
                                    <i className="bi bi-check-circle-fill"></i>
                                  </div>
                                  <div>
                                    <div
                                      className="text-muted fw-semibold text-uppercase"
                                      style={{
                                        fontSize: "11px",
                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      Active Subscriptions
                                    </div>
                                    <div className="d-flex align-items-baseline gap-2 mt-1 flex-wrap">
                                      <span className="fs-3 fw-bold text-dark lh-1">
                                        {activeSubscriptionsCount}
                                      </span>
                                      <span
                                        className="badge bg-success-subtle text-success border border-success-subtle rounded-pill px-2 py-1 d-inline-flex align-items-center gap-1"
                                        style={{ fontSize: "11px", fontWeight: 600 }}
                                      >
                                        <i className="bi bi-people-fill"></i> {activeKidsCount}{" "}
                                        {activeKidsCount === 1 ? "kid" : "kids"} covered
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-12 col-md-4">
                                <div className="p-2 p-sm-3 bg-white rounded-3 border h-100 shadow-sm d-flex align-items-center">
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                    style={{
                                      background: "#f1f5f9",
                                      color: "#475569",
                                      width: "48px",
                                      height: "48px",
                                      fontSize: "22px",
                                      flexShrink: 0,
                                    }}
                                  >
                                    <i className="bi bi-collection-fill"></i>
                                  </div>
                                  <div>
                                    <div
                                      className="text-muted fw-semibold text-uppercase"
                                      style={{
                                        fontSize: "11px",
                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      Total Subscriptions
                                    </div>
                                    <div className="d-flex align-items-baseline gap-2 mt-1 flex-wrap">
                                      <span className="fs-3 fw-bold text-dark lh-1">
                                        {totalSubscriptionsCount}
                                      </span>
                                      <span
                                        className="badge bg-secondary-subtle text-secondary border border-secondary-subtle rounded-pill px-2 py-1 d-inline-flex align-items-center gap-1"
                                        style={{ fontSize: "11px", fontWeight: 600 }}
                                      >
                                        <i className="bi bi-person-lines-fill"></i> {totalKidsCount} total{" "}
                                        {totalKidsCount === 1 ? "kid" : "kids"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-12 col-md-4">
                                <div className="p-2 p-sm-3 bg-white rounded-3 border h-100 shadow-sm d-flex align-items-center">
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                    style={{
                                      background: "#eef2ff",
                                      color: "#4f46e5",
                                      width: "48px",
                                      height: "48px",
                                      fontSize: "22px",
                                      flexShrink: 0,
                                    }}
                                  >
                                    <i className="bi bi-cash-stack"></i>
                                  </div>
                                  <div>
                                    <div
                                      className="text-muted fw-semibold text-uppercase"
                                      style={{
                                        fontSize: "11px",
                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      Total Paid
                                    </div>
                                    <div className="d-flex align-items-baseline gap-2 mt-1 flex-wrap">
                                      <span className="fs-3 fw-bold text-dark lh-1">
                                        {currencySymbol} {paidAmount}
                                      </span>
                                      <span
                                        className="text-muted small"
                                        style={{ fontSize: "11px" }}
                                      >
                                        All-time billing
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Subscriptions & Invoices Section */}
                          <div className="p-3 p-sm-4 bg-white rounded-3 border shadow-sm parent-billing-section">
                            <h5 className="fw-bold text-dark mb-1">
                              Subscription Details & Invoices
                            </h5>
                            <p className="text-muted small mb-4">
                              Manage active plans, download invoices, or cancel subscriptions.
                            </p>

                            <SubscriptionHistoryModal
                              show={true}
                              loading={loadingSubscriptions}
                              histories={selectedHistories}
                              invoices={selectedInvoice}
                              currency={subscriptionDetails?.user?.currency}
                              planId={subscriptionDetails?.user?.plan_id}
                              subscriptionCancel={handleSubscriptionCancelled}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
